import SpikeChart from "./SpikeChart";

export default SpikeChart;
